import { includes } from "lodash";

const stringTypes = ["text", "category"];

const isStringType = (type) => includes(stringTypes, type);

export { isStringType };
